import React from 'react';
import { observer } from 'mobx-react';
import { routeNode } from 'core/routing';
import { FourOhFour } from 'apps/fourOhFour/index';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { AboutUs } from 'apps/home/company/about/index';
import { OurStory } from 'apps/home/company/ourStory/index';
import { Careers } from 'apps/home/company/careers/index';

const viewsMap = {
  about: AboutUs,
  story: OurStory,
  careers: Careers,
};

@withNamespaces()
@observer
class CompanySpace extends React.Component {
  UNSAFE_componentWillMount() {
    const { route, routerStore } = this.props;
    if (route.name === 'home.company') {
      routerStore.router.navigate('home.company.about');
    }
  }

  render() {
    const View = this.props.componentFromRoute();
    return <View params={this.props.params} />;
  }
}

CompanySpace.propTypes = {
  params: PropTypes.object,
  route: PropTypes.object,
  routerStore: PropTypes.object,
  componentFromRoute: PropTypes.func,
};

export const CompanyRouter = routeNode(
  'home.company',
  viewsMap,
  FourOhFour,
)(CompanySpace);
